import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronUpIcon, FilterIcon } from '@umanforge/common';
import useFilterSelector from '../hook/filterSelector.hook';
import { ChartFilter } from 'interfaces/chart.interface';


interface FilterSelectorProps {
  className?: string;
  onChange: ( filters: ChartFilter ) => void;
  onOpen?: ( open: boolean ) => void;
  isOpen?: boolean;
  sectorId: string;
}

const FilterSelector: React.FC<FilterSelectorProps> = ( {
  className = 'w-full',
  onChange,
  onOpen = () => { return; },
  sectorId,
  isOpen = false
} ) => {
  const { t } = useTranslation();

  const {
    taskActions,
    locations,
    equipments,
    //timeGrids,
    users,

    onChangeFilteredLocations,
    onChangeFilteredTaskActions,
    onChangeFilteredEquipments,
    onChangeFilteredUsers,
    //onChangeFilteredTimeGrids,
    selectedTaskActions,
    selectedLocations,
    selectedEquipments,
    //selectedTimeGrids,
    selectedUsers,
  } = useFilterSelector( sectorId, onChange );

  const [ open, setOpen ] = useState<boolean>( isOpen );

  return (
    <div className={`rounded-md ${className} p-3 border-gray-200 ${ open ? 'relative' : 'absolute'} `} >
      <div className='relative w-full mb-2 flex items-center'>
        <div
          id={'filters_open_button'}
          className={'h-10 px-3 w-fit flex items-center rounded-lg  bg-gray-300'}
          onClick={ () => { setOpen( !open ); onOpen( !open ); } }
        >
          <label htmlFor={'filters_open_button'} className='w-fit px-2 text-center whitespace-nowrap flex justify-center'>
            <FilterIcon className='mr-2 stroke-gray-400 w-6 h-6'/>
            { t( 'common:filters' ) }
          </label>

          { <ChevronUpIcon className={`p-1 ${open && 'rotate-180'}`} /> }
        </div>
      </div>

      { open &&
        <div className='w-80 truncate h-full flex flex-col gap-y-3'>
          <div className='ml-1.5'>
            <p>{ t( 'translation:locations' )}</p>
            {
              locations ?
                locations.map( location => {
                  return (
                    <div key={ location.id } className='flex flex-col mb-1'>
                      <div className='flex gap-2 items-center select-none'>
                        <input
                          type='checkbox'
                          id={ location.id }
                          className='h-fit cursor-pointer'
                          checked={ selectedLocations.find( obj => { return obj === location.id; } ) != null }
                          onChange={ e => { onChangeFilteredLocations( location.id, ( e.target as HTMLInputElement ).checked ); } }
                        />
                        <label htmlFor={ location.id } className='cursor-pointer truncate text-xs'>{ location.name }</label>
                      </div>
                    </div>
                  );
                } )
                :
                null
            }
          </div>
          <div className='ml-1.5'>
            <p>{ t( 'common:equipments' )}</p>
            {
              equipments ?
                equipments.map( equipment => {
                  return (
                    <div key={ equipment.id } className='flex flex-col mb-1'>
                      <div className='flex gap-2 items-center select-none'>
                        <input
                          type='checkbox'
                          id={ equipment.id }
                          className='h-fit cursor-pointer'
                          checked={ selectedEquipments.find( obj => { return obj === equipment.id; } ) != null }
                          onChange={ e => { onChangeFilteredEquipments( equipment.id, ( e.target as HTMLInputElement ).checked ); } }
                        />
                        <label htmlFor={ equipment.id } className='cursor-pointer truncate text-xs'>{ equipment.name }</label>
                      </div>
                    </div>
                  );
                } )
                :
                null
            }
          </div>
          <div className='ml-1.5'>
            <p>{ t( 'translation:task_actions' )}</p>
            {
              taskActions ?
                taskActions.map( taskAction => {
                  return (
                    <div key={ taskAction.id } className='flex flex-col mb-1'>
                      <div className='flex gap-2 items-center select-none'>
                        <input
                          type='checkbox'
                          id={ taskAction.id }
                          className='h-fit cursor-pointer'
                          style={{ content: '' }}
                          checked={ selectedTaskActions.find( obj => { return obj === taskAction.id; } ) != null }
                          onChange={ e => { onChangeFilteredTaskActions( taskAction.id, ( e.target as HTMLInputElement ).checked ); } }
                        />
                        <label htmlFor={ taskAction.id } className='cursor-pointer truncate text-xs'>{ taskAction.name }</label>
                      </div>
                    </div>
                  );
                } )
                :
                null
            }
          </div>
          <div className='ml-1.5'>
            <p>{ t( 'common:users' )}</p>
            {
              users ?
                users.map( user => {
                  return (
                    <div key={ user.id } className='flex flex-col mb-1'>
                      <div className='flex gap-2 items-center select-none'>
                        <input
                          type='checkbox'
                          id={ user.id }
                          className='h-fit cursor-pointer'
                          checked={ selectedUsers.find( obj => { return obj === user.id; } ) != null }
                          onChange={ e => { onChangeFilteredUsers( user.id, ( e.target as HTMLInputElement ).checked ); } }
                        />
                        <label htmlFor={ user.id } className='cursor-pointer truncate text-xs'>{ user.fullname }</label>
                      </div>
                    </div>
                  );
                } )
                :
                null
            }
          </div>
          {/* <div className='ml-1.5'>
            <p>{ t( 'translation:time_grids' )}</p>
            {
              timeGrids ?
                timeGrids.map( timeGrid => {
                  return (
                    <div key={ timeGrid.id } className='flex flex-col mb-1'>
                      <div className='flex gap-2 items-center select-none'>
                        <input
                          type='checkbox'
                          id={ timeGrid.id }
                          className='h-fit cursor-pointer relative'
                          checked={ selectedTimeGrids.find( obj => { return obj === timeGrid.id; } ) != null }
                          onChange={ e => { onChangeFilteredTimeGrids( timeGrid.id, ( e.target as HTMLInputElement ).checked ); } }
                        />
                        <label htmlFor={ timeGrid.id } className='cursor-pointer truncate text-xs'>{ timeGrid.name }</label>
                      </div>
                    </div>
                  );
                } )
                :
                null
            }
          </div> */}
        </div>
      }
    </div>
  );
};

export default FilterSelector;
